import { useRequest } from 'ahooks';
import _ from 'lodash-es';
import {
  RequrstBack,
  queryInitStatClientConfig,
} from '@/pages/datalab/pages/BehaviorAnalysis/GptAnalysis/hooks';
import http from '@/utils/http';
/*
// Streaming首页Card
export const useStreamingKolRank = <T>(params: T) => {
  const fetch = (mutateParams?: T) =>
    http({
      url: '/api/v1/intelligence_pc/streamingKolRank',
      method: 'post',
      data: params,
      rawData: true,
      ...mutateParams,
    }) as RequrstBack;
  const { data, ...resProps } = useRequest(fetch, {
    ...queryInitStatClientConfig,
    refreshDeps: [params],
    ready: !!params,
    cacheKey: 'kolRank',
    manual: false,
    loadingDelay: 0,
  });
  return {
    data,
    ...resProps,
  };
};
*/
// Streaming详情页表格
export const useStreamingKolRankList = <T>(params: T) => {
  const fetch = (mutateParams: T) =>
    http({
      url: '/api/v1/intelligence_pc/streamingKolRankList',
      method: 'post',
      data: params,
      rawData: true,
      ...mutateParams,
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    retryCount: 0,
    refreshDeps: [params],
    ready: !!params,
    cacheKey: 'rankList',
    manual: false,
    loadingDelay: 100,
  });
  return {
    ...data,
  };
};

// Streaming详情页图表
export const useStreamingKolTrend = <T>(params: T) => {
  const fetch = (mutateParams: T) =>
    http({
      url: '/api/v1/intelligence_pc/streamingKolTrend',
      method: 'post',
      data: params,
      ...mutateParams,
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    retryCount: 0,
    refreshDeps: [params],
    // 当表格数据加载完成后才开始请求，图表依赖表格的参数
    ready: !_.isEmpty(params.user_ids) && !!params,
    cacheKey: 'kolTrend',
    loadingDelay: 1200,
    debounceWait: 1000,
  });
  return {
    ...data,
  };
};

// Streaming详情页搜索接口
export const useStreamingKolSearch = <T>(params?: T) => {
  const kolUserOrGamsFetchUrl = {
    kol_game: '/api/v1/intelligence_pc/searchStreamingKolGame',
    kol_anchor: '/api/v1/intelligence_pc/searchStreamingKolUser',
    games: '/api/v1/intelligence_pc/search/streaming_game', // 联调新接口，youbin
    // games: '/api/v1/intelligence_pc/streamingGameSearch'
  }[params as string];
  const fetch = (mutateParams: T, config?: T) =>
    http({
      ...config,
      url: kolUserOrGamsFetchUrl,
      method: 'post',
      data: mutateParams,
      // ...mutateParams,
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    retryCount: 0,
    refreshDeps: [params],
    ready: !!params,
    cacheKey: 'kolSearch',
    loadingDelay: 300,
    manual: true,
  });
  return {
    ...data,
  };
};
